import { map, reduce } from "lodash";
import { useInjection } from "@linkfluence/core/di";
import { Platform } from "@linkfluence/models/platform";
import { useQueries } from "@tanstack/react-query";
import { CorporaRepo, CorporaRepositoryUID } from "../repositories/CorporaRepo";

export function useCorporaAllSources(
  project: number,
  corpuses: { id: number; platforms: string[] }[],
  sourcesPerPage: number = 100
) {
  const repository = useInjection<CorporaRepo>(CorporaRepositoryUID);

  const corpusSources = reduce(
    corpuses,
    (acc, corpus) => {
      return reduce(
        corpus.platforms,
        (acc, platform) => {
          acc.push({ id: corpus.id, platform: platform });
          return acc;
        },
        acc
      );
    },
    []
  );

  const allSources = useQueries({
    queries: map(corpusSources, (corpusPlatform) => ({
      queryKey: [
        "/corpora-platform-sources-all/get", // TODO: Merge with `/corpora-platform-sources/get` which is used by a useInfiniteQuery
        {
          project,
          platform: corpusPlatform.platform,
          corpusId: corpusPlatform.id,
        },
      ],
      queryFn: async () => {
        const sources = await repository.getCorporaPlatformSources(
          project,
          corpusPlatform.id,
          corpusPlatform.platform as Platform,
          {
            count: sourcesPerPage,
            offset: 0,
            orderBy: "name",
            search: "",
            sort: "asc",
          }
        );
        // @ts-ignore sources has data
        return map(sources.data, (source) => ({
          ...source,
          platform: corpusPlatform.platform,
        }));
      },
    })),
  });

  const loading = allSources.some((source) => source.isLoading);

  const formatResults = (promises) => {
    return reduce(
      promises,
      (acc, promise) => {
        if (promise.status === "success") {
          acc = acc.concat(promise.data);
        }
        return acc;
      },
      []
    );
  };

  return { loading, allSources: !loading ? formatResults(allSources) : [] };
}
